import { api } from '../../../services/api';

export interface RuleDTO {
  id: string;
  companyId: string;
  type: 'INCOME' | 'EXPENSE';
  counterpartDocument: string | null;
  counterpartDocumentType: string | null;
  descriptionTokens: string[];
  categoryId: string;
  categoryName: string;
  beneficiaryCompanyId: string | null;
  beneficiaryCompanyName: string | null;
  excludedFromDre: boolean;
  excludedFromCashFlow: boolean;
  isCardSettlement: boolean;
  status: 'ACTIVE' | 'DISABLED';
  origin: 'HISTORY' | 'APPROVAL' | 'MANUAL';
  hits: number;
  lastHitAt: string | null;
  contestations: number;
  lastContestedAt: string | null;
  disabledReason: string | null;
  createdByProposalId: number | null;
  createdAt: string;
}

export interface NewRuleInput {
  companyId: string;
  type: 'INCOME' | 'EXPENSE';
  categoryId: string;
  counterpartDocument: string | null;
  descriptionTokens: string[] | null;
  beneficiaryCompanyId: string | null;
  excludedFromDre: boolean;
  excludedFromCashFlow: boolean;
  isCardSettlement: boolean;
}

export const rulesService = {
  list: (companyId: string) =>
    api
      .get<{ success: boolean; data: RuleDTO[] }>('/financial/rules', { params: { companyId } })
      .then((r) => r.data.data),
  create: (input: NewRuleInput) =>
    api
      .post<{ success: boolean; data: RuleDTO }>('/financial/rules', input)
      .then((r) => r.data.data),
  setStatus: (id: string, status: 'ACTIVE' | 'DISABLED', reason?: string | null) =>
    api
      .patch<{ success: boolean; data: RuleDTO }>(`/financial/rules/${id}`, {
        status,
        ...(reason ? { reason } : {}),
      })
      .then((r) => r.data.data),
};
